// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__mikNQ","routeTvOn":"Layout_routeTvOn__iarPl","tvOn":"Layout_tvOn__9Ppk4","educationBg":"Layout_educationBg__42pYu"};